//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { EventsNames } from '../../../helpers/events-names'
import { i18n } from '../../common/i18n/common.i18n'
import { CommonHelper } from '../../../helpers/common-helper'
import { ColumnModel } from '../../api/api.models'

interface DefinitionEditScope extends ng.IScope {

    source: any

    alarmDefsSelect: DevExpress.ui.dxSelectBoxOptions
    refTypeRadio: DevExpress.ui.dxRadioGroupOptions

    defRefSelect: DevExpress.ui.dxSelectBoxOptions
    defRefText: DevExpress.ui.dxTextBoxOptions
    defRefBoolean: DevExpress.ui.dxSelectBoxOptions
    defTypeSelect: DevExpress.ui.dxSelectBoxOptions
    unitForDef: any
    showDefTypeUnits: boolean

    defSwitch: DevExpress.ui.dxSwitchOptions
    defSwitchValue: boolean

    enableSwitch: DevExpress.ui.dxSwitchOptions
    enableSwitchValue: boolean
    enableSwitchControl: DevExpress.ui.dxSwitch

    deleteDefButton: DevExpress.ui.dxButtonOptions

    isEdit: boolean
    
    defSelectValidator: DevExpress.ui.dxValidatorOptions
    refSelectValidator: DevExpress.ui.dxValidatorOptions
    alarmTypeValidator: DevExpress.ui.dxValidatorOptions
    ownRefValidator: DevExpress.ui.dxValidatorOptions
    defRefBooleanValidator: DevExpress.ui.dxValidatorOptions

    switchControl: DevExpress.ui.dxSwitch
    validatorControl: DevExpress.ui.dxValidator
    defSelect: DevExpress.ui.dxSelectBox
    defText: DevExpress.ui.dxTextBox

    originalIdConfig: number
    originalAlarmType: number
    originalAlarmData: number
    originalAlarmValue: any
    originalAlarmEnabled: boolean

    types: any
    units: any

    showExtendedData: boolean

    defFields: ColumnModel[]
    defRefsFields: ColumnModel[]

    initializeValidationGroup: (e: any) => void
}

import './definition-edit.scss'
import * as TEMPLATE from './definition-edit.tpl.html'

export class DefinitionEditDirective implements ng.IDirective {
    constructor() {
    }
    restrict = 'E'
    scope = {
        source: '=',
        types: '=',
        showExtendedData: '=',
        defFields: '=',
        defRefsFields: '='
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', 'localDictionary', ($scope: DefinitionEditScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory) => {

        $scope.isEdit = false

        localDictionary.getUnits().then(result => {
            $scope.units = result
        })

        var setUnitForDef = (alarm) => {
            alarm = parseInt(alarm)
            localDictionary.getIdUnitByIdDataType(alarm).then(unitId => {
                for (var i = 0; i < $scope.units.length; i++) {
                    var unit = $scope.units[i]
                    if (unit.id == unitId) {
                        $scope.unitForDef = unit.caption
                        break
                    }
                }
            })
        }

        $scope.initializeValidationGroup = (e) => {
            if ($scope.source.isVisible)
                $scope.source.validationGroup = e.component
        }

        if ($scope.source.id === 0) {
            $scope.source.originalSysAlarmVal = angular.copy($scope.source.systemAlarmValue)
            $scope.source.originalIdDataTypeConfig = angular.copy($scope.source.idDataTypeConfig)
        }

        if ($scope.source.idDataTypeAlarm) {
            $scope.originalAlarmData = $scope.source.idDataTypeAlarm
            $scope.originalAlarmValue = $scope.source.systemAlarmValue ? $scope.source.systemAlarmValue : ""
            $scope.originalIdConfig = $scope.source.idDataTypeConfig
        }

        $scope.originalAlarmEnabled = $scope.source.isEnabled

        $scope.$on('refreshDefsForm', (event: ng.IAngularEvent, ...args: any[]) => {
            if ($scope.source.isNewFromTemplate) {
                if ($scope.defSelect)
                    $scope.defSelect.reset()
                if ($scope.defText)
                    $scope.defText.reset()

                if ($scope.enableSwitchControl != null) {
                    $scope.enableSwitchControl.reset()
                }
            }

            if ($scope.source.id != 0) {
                $scope.source.idDataTypeConfig = $scope.originalIdConfig
                if ($scope.defSelect) {
                    $scope.defSelect.option('value', $scope.originalIdConfig)
                }
                $scope.source.systemAlarmValue = $scope.originalAlarmValue
                if ($scope.defText) {
                    $scope.defText.option('value', $scope.originalAlarmValue)
                }

                $scope.source.isEnabled = $scope.originalAlarmEnabled
                if ($scope.enableSwitchControl != null) {
                    $scope.enableSwitchControl.option('value', $scope.originalAlarmEnabled)
                }
            }
            if ($scope.source.id === 0) {
                $scope.source.idDataTypeConfig = $scope.source.originalIdDataTypeConfig
                $scope.source.systemAlarmValue = $scope.source.originalSysAlarmVal
            }
            $scope.source.toDelete = false
            $scope.source.opState = CommonHelper.ChangeState.Loaded
        })

        $scope.$watch('source.toDelete', (val) => {
            if (val) {
                if ($scope.switchControl)
                    $scope.switchControl.option('disabled', true)
                if ($scope.defSelect)
                    $scope.defSelect.option('disabled', true)
                if ($scope.defText)
                    $scope.defText.option('disabled', true)
            } else {
                if ($scope.switchControl)
                    $scope.switchControl.option('disabled', false)
                if ($scope.defSelect)
                    $scope.defSelect.option('disabled', false)
                if ($scope.defText)
                    $scope.defText.option('disabled', false)
            }

        })

        $scope.alarmDefsSelect = {
            placeholder: $scope.source.dataTypeAlarmDescr != null && $scope.source.dataTypeAlarmDescr !== '' ? $scope.source.dataTypeAlarmDescr : $scope.source.dataTypeAlarmName != null ? $scope.source.dataTypeAlarmName : i18n("Common", "Select"),
            value: $scope.source.idDataTypeAlarm,
            readOnly: !$scope.source.isNew,
            onValueChanged: (e) => {
                $scope.source.idDataTypeAlarm = e.value
                if ($scope.defFields.map(x => x.id).indexOf(e.value) >= 0) {
                    var classType = $scope.defFields.filter(c => c.id == e.value)[0].type
                    $scope.source.idDataTypeClass = classType
                }
                alarmDefUpdated()
            },
            dataSource: $scope.defFields,
            displayExpr: 'caption',
            valueExpr: 'id',
            noDataText: i18n('Common', 'NoData')
        }

        $scope.defSelectValidator = {
            validationRules: [{
                type: "required",
                reevaluate: true,
                message: i18n("Common", "RequiredField")
            }],
        }

        $scope.alarmTypeValidator = {
            validationRules: [{
                type: "required",
                message: i18n("Common", "RequiredField")
            }],
        }

        $scope.refSelectValidator = {
            validationRules: [{
                type: 'required',
                message: i18n("Common", "RequiredField")
            }, {
                    type: 'custom',
                    reevaluate: true,
                    message: i18n("Common", "RequiredField"),
                    validationCallback: options => {
                        var nbr = new Number(options.value).valueOf()
                        if (nbr === 0) {
                            if ($scope.source.id != 0 || $scope.source.isNewFromTemplate) {
                                return false
                            } else return true
                        } else return true
                    }
                }],
            onInitialized: e => {
                $scope.validatorControl = e.component
            },
            bindingOptions: {
                disabled: 'source.readOnly'
            }
        }

        $scope.ownRefValidator = {
            validationRules: [
                {
                    type: 'required',
                    message: i18n("Common", "RequiredField")
                },
                {
                    type: 'custom',
                    reevaluate: true,
                    validationCallback: (options) => {
                        switch ($scope.source.idDataTypeClass) {
                            case CommonHelper.integer: {
                                var pattern = /^\d+$/
                                var str = options.value.toString()
                                if (!pattern.test(str)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "TypeInteger")
                                    return false
                                } else return true
                            }
                            case CommonHelper.real: {
                                var pattern = /^[-+]?[0-9]*(\.|,)?[0-9]+([eE][-+]?[0-9]+)?$/
                                var str = options.value.toString()
                                if (!pattern.test(str)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "TypeReal")
                                    return false
                                } else return true
                            }
                            case CommonHelper.decimal: {
                                var pattern = /^(?:\d*\.)?\d+$/
                                var str = options.value.toString()
                                if (!pattern.test(str)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "TypeDecimal")
                                    return false
                                } else return true
                            }
                            case CommonHelper.binary: {
                                var pattern = /^[0,1]+$/
                                var str = options.value.toString()
                                if (!pattern.test(str)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "TypeBinary")
                                    return false
                                } else return true
                            }
                            case CommonHelper.boolean: {
                                var pattern = /^[0,1]$|^\b[T,t]rue$|^\b[F,f]alse$|^[T,F,t,f]$/
                                var str = options.value.toString()
                                if (!pattern.test(str)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "TypeBoolean")
                                    return false
                                } else return true
                            }
                            case CommonHelper.date: {
                                var pattern = /^([12]{1}\d{3})((-{1}([0]{1}[1-9]?|[1]{1}[0-2]?)?)?(-{1}([0]{1}[1-9]?|[1-2]{1}\d?|[3]{1}[01]?)?)?)?$/g
                                var str = options.value.toString()
                                if (!pattern.test(str)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "TypeDate")
                                    return false
                                } else return true
                            }
                            case CommonHelper.time: {
                                var pattern = /^([0-1]\d|2[0-3])(?::([0-5]\d))?$/g
                                var str = options.value.toString()
                                if (!pattern.test(str)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "TypeTime")
                                    return false
                                } else return true
                            }
                            case CommonHelper.datetime: {
                                var pattern = /^([12]{1}\d{3})((-{1}([0]{1}[1-9]?|[1]{1}[0-2]?)?)?(-{1}([0]{1}[1-9]?|[1-2]{1}\d?|[3]{1}[01]?)?)?)? (([0-1]\d|2[0-3])(?::([0-5]\d)))$/g
                                var str = options.value.toString()
                                if (!pattern.test(str)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "TypeDatetime") + ": YYYY-MM-DD HH:mm"
                                    return false
                                } else return true
                            }
                            case CommonHelper.text:
                            case CommonHelper.xml: {
                                if (!angular.isString(options.value)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + i18n("Common", "Type" + $scope.source.ownRefType)
                                    return false
                                } else return true
                            }
                            default: {
                                if (!angular.isDefined(options.value)) {
                                    options.rule.message = i18n("Common", "FieldOfType") + $scope.source.ownRefType
                                    return false
                                } else return true
                            }
                        }
                    }
                }],
        }

        $scope.defRefBooleanValidator = {
            validationRules: [{
                type: "custom",
                message: i18n("Common", "RequiredField"),
                validationCallback: (options) => {
                    if (options.value == null || options.value == undefined) {
                        return false
                    }
                    return true
                }
            }],
        }

        $scope.defSwitchValue = !!$scope.source.systemAlarmValue

        $scope.defSwitch = {
            onText: i18n('Popup', 'AlarmDefRefTypeOwn'),
            offText: i18n('Popup', 'AlarmDefRefTypeList'),
            value: $scope.source.systemAlarmValue != null && typeof $scope.source.systemAlarmValue != 'undefined',
            width: '80%',
            onValueChanged: (e) => {
                $scope.defSwitchValue = e.value
                $scope.source.isOwnRef = e.value
                $scope.source.modified = true
                if (!e.value) {
                    $scope.source.idDataTypeConfig = 0
                    if ($scope.defSelect) $scope.defSelect.option('value', null)
                }
                alarmDefUpdated()
                e.component.repaint()
            },
            onInitialized: (e) => {
                $scope.switchControl = e.component
                if ($scope.defRefsFields.length > 0)
                    e.component.option('value', !(!$scope.source.systemAlarmValue))
                else
                    e.component.option('value', true)
                $timeout(() => {
                    $scope.defSwitchValue = e.component.option('value')
                    $scope.source.isOwnRef = e.component.option('value')
                    e.component.repaint()
                })
            },
            disabled: $scope.source.readOnly
        }


        $scope.showDefTypeUnits = isNaN($scope.source.systemAlarmValue) ? false : true
        $scope.unitForDef = setUnitForDef($scope.source.idDataTypeAlarm)

        $scope.enableSwitch = {
            hint: i18n('Common', 'Active'),
            value: $scope.source.isEnabled,
            onValueChanged: (e) => {
                $scope.enableSwitchValue = e.value
                $scope.source.isEnabled = e.value
                $scope.source.modified = true
                alarmDefUpdated()
            },
            onInitialized: (e) => {
                $scope.enableSwitchControl = e.component
                e.component.option('value', $scope.source.isEnabled)
                $timeout(() => {
                    $scope.enableSwitchValue = e.component.option('value')
                    $scope.source.isEnabled = e.component.option('value')
                    e.component.repaint()
                })
            }
        }

        angular.element(window).on('resize', () => {
            $timeout(() => {
                $scope.switchControl.repaint()
            })
        })

        $scope.defTypeSelect = {
            onInitialized: (e) => {
                $scope.originalAlarmType = $scope.source.idAlarmType
            },
            onValueChanged: (e) => {
                $scope.source.idAlarmType = e.value
                alarmDefUpdated()
            },
            placeholder: i18n("Common", "Select"),
            dataSource: $scope.types.result,
            displayExpr: 'caption',
            value: $scope.source.idAlarmType,
            valueExpr: 'id',
            readOnly: !$scope.source.isNew,
            noDataText: i18n('Common', 'NoData')
        }

        $scope.defRefText = {
            onInitialized: e => {
                $scope.defText = e.component
            },
            onKeyDown: e => {
                alarmDefUpdated()
            },
            disabled: $scope.source.readOnly,
            onValueChanged: (e) => {
                if ($scope.defSwitchValue === true) {
                    var value = typeof e.value === 'string' ? e.value.replace(',', '.') : e.value;

                    switch ($scope.source.idDataTypeClass) {
                        case CommonHelper.integer:
                        case CommonHelper.real:
                        case CommonHelper.decimal:
                        case CommonHelper.binary:
                            value = +value
                            break
                    }
                    $scope.source.systemAlarmValue = value
                }
                if (e.value != e.previousValue) {
                    $scope.source.modified = true
                    alarmDefUpdated()
                }
            },
            value: $scope.source.systemAlarmValue ? $scope.source.systemAlarmValue : null
        }

        $scope.defRefBoolean = {
            dataSource: [
                {
                    value: true,
                    text: i18n('Common', 'True')
                },
                {
                    value: false,
                    text: i18n('Common', 'False')
                }
            ],
            placeholder: i18n("Common", "Select"),
            valueExpr: 'value',
            displayExpr: 'text',
            onValueChanged: (e) => {
                if ($scope.defSwitchValue === true) {
                    $scope.source.idDataTypeConfig = 0
                    $scope.source.systemAlarmValue = e.value
                }
                alarmDefUpdated()
            },
            disabled: $scope.source.readOnly,
            value: typeof $scope.source.systemAlarmValue != 'undefined' && $scope.source.systemAlarmValue != null ? $scope.source.systemAlarmValue.toString().toLowerCase() == 'true' : undefined
        }

        const found = _.find($scope.defRefsFields, field => field.id == $scope.source.idDataTypeConfig)
        if (!found)
            $scope.source.idDataTypeConfig = 0

        $scope.defRefSelect = {
            placeholder: i18n("Common", "Select"),
            onInitialized: (e) => {
                $scope.defSelect = e.component
            },
            onValueChanged: (e) => {
                if ($scope.defSwitchValue === false) {
                    $scope.source.dataTypeAlarmName = e.component.option('text')
                    $scope.source.idDataTypeConfig = e.value
                }
                $scope.source.modified = true
                alarmDefUpdated()
            },
            dataSource: $scope.defRefsFields,
            bindingOptions: {
                value: 'source.idDataTypeConfig'
            },
            disabled: $scope.source.readOnly,
            displayExpr: 'caption',
            valueExpr: 'id',
            noDataText: i18n('Common', 'NoData')
        }

        $scope.deleteDefButton = {
            hint: i18n('Popup', 'AlarmDefDelete'),
            icon: 'trash',
            onClick: () => {
                $scope.$emit(EventsNames.DELETE_METER_DEF, $scope.source)
                alarmDefUpdated(true)
            }
        }

        const alarmDefUpdated = (isDelete: boolean = false) => {
            $scope.$emit(EventsNames.ALARM_DEF_UPDATED)
            if ($scope.source.opState === CommonHelper.ChangeState.Loaded)
                $scope.source.opState = CommonHelper.ChangeState.Modified

            if (isDelete) {
                if ($scope.source.toDelete)
                    $scope.source.opState = CommonHelper.ChangeState.Delete
                else
                    $scope.source.opState = CommonHelper.ChangeState.Modified
            }
        }
    }]

    template = TEMPLATE
}